export default __webpack_public_path__ + "static/media/40.69634ba4.png";